import Immutable from "immutable";
import { COLLECTION_SHAPE } from "../../../config/shapes";
import { LOAD_DRIVER_ACTIVITY, GET_DRIVER_ACTIVITY, CLEAR_DRIVER_ACTIVITY } from "../../../actions/types";

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
})

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case LOAD_DRIVER_ACTIVITY:
      return state.setIn(['all', 'loading'], payload);
    case GET_DRIVER_ACTIVITY:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_DRIVER_ACTIVITY:
      return state.setIn(['all', 'content'], Immutable.Map(COLLECTION_SHAPE));
    default:
      return state;
  }
}